<template>
    <v-checkbox v-bind="{ ...attrs_controls_common, ...$attrs }">
        <template v-slot:label>
            <strong class="yellow--text">{{ label }}</strong>
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-checkbox>
</template>

<script>
import { attrs_controls_common } from "@/assets/variables";

export default {
    props: {
        label: { type: String, default: "" },
    },
    components: {},
    data: () => {
        return {
            attrs_controls_common,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
